import React from 'react';
import clsx from 'clsx';

/**
 * @param {string} props.label - label of row that is used inside edit data element pop up 
 * @param {boolean} props.displayContent - state that displays/hides content below row 
 * @param {setState} props.setDisplayContent - hook method that handles displayContent
 * @param {method} props.deleteElement - method that handles deletion of row
 * @param {boolean} props.hideDelete - state that display/hide delete row button
 * @param {method} props.clearAll - clear all options inside content of row element
 * @param {boolean} props.showClearAll - display/hide clear all button 
 * @returns general title row component of a data element
 */
const RowElement = (props) => {

    const {
        label,
        displayContent,
        setDisplayContent,
        deleteElement,
        hideDelete,
        clearAll,
        showClearAll
    }= props;


    // Method that display/hide content of row element
    const changeDisplayContent = () => {
        setDisplayContent(!displayContent);
    }

    return(

        <div className={clsx('flexRowDirection')}  style={{justifyContent: 'space-between'}}>
            <div className={clsx('flexRowDirection','teamSelector')} onClick ={changeDisplayContent} aria-hidden="true">
                
                <i id="gjs-sm-caret"  
                    className={ displayContent === true ? 'fa fa-caret-down fa-caret-down-blue' : 'fa fa-caret-right fa-caret-right-blue'}
                 aria-hidden="true"/>
                <span className={clsx('boldBlue')}>&nbsp;{label}</span>
            </div>
            { hideDelete === true || showClearAll === true ?
                null
                :
                <i className={clsx('fas', 'fa-times-circle', 'teamSelector')}  style={{display: 'inline-block', paddingTop: '0.2vw'}}
                    onClick ={() => deleteElement()}
                    aria-hidden="true"
                />
            }
            { showClearAll === true && displayContent && 
                <span className={clsx('clearAllStyle', 'teamSelector')} onClick ={ () => clearAll()} aria-hidden="true"> Clear all</span>
            }
            
        </div>
    )

}

export default RowElement;